export async function setNativeAppBadge(count) {
    try {
        const cap = window?.Capacitor;
        const badge = cap?.Plugins?.Badge;
        if (!badge || typeof badge.set !== "function") return;

        const safeCount = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;
        await badge.set({ count: safeCount });
    } catch (_) {
        // Ignore: web build, unsupported launcher, or plugin not installed.
    }
}
